import { CancelBtnType } from '../core/types/app-cancel-btn.type';
import { AppLoginType } from '../core/types/app-login.type';

export const Theme = {
  loginType: AppLoginType.LoginWithCarousel,
  cancelBtnType: CancelBtnType.Red,
};
